export const findHashtag = (hashCount: number, value: string, triggerChar = '#') => {
  let currentHashes = hashCount
  let index = -1

  for (let ix = 0, length = value?.length; ix < length; ix++) {
    const char = value[ix]

    if (char === triggerChar) {
      currentHashes -= 1

      if (currentHashes === 0) {
        index = ix
        break;
      }
    }
  }

  return index
}
